// pages/PartidasEstandar.jsx

import React, { useState, useEffect } from 'react';
import api from '../services/api';
import Swal from 'sweetalert2';
import '../styles/Materiales.css'; // Reutilizar CSS de materiales

const PartidasEstandar = () => {
  const [partidas, setPartidas] = useState([]);
  const [categorias, setCategorias] = useState([]);
  const [loading, setLoading] = useState(true);
  const [categoriaFiltro, setCategoriaFiltro] = useState('');
  const [busqueda, setBusqueda] = useState('');
  const [mostrarModal, setMostrarModal] = useState(false);
  const [editando, setEditando] = useState(null);
  const [formData, setFormData] = useState({
    CategoriaPartidaId: '',
    codigo: '',
    nombre: '',
    unidad: 'glb',
    precio_referencia: '',
    descripcion: ''
  });

  useEffect(() => {
    cargarDatos();
  }, []);

  useEffect(() => {
    cargarPartidas();
  }, [categoriaFiltro]);

  const cargarDatos = async () => {
    try {
      setLoading(true);
      const [resCategorias, resPartidas] = await Promise.all([
        api.get('/categorias-partida'),
        api.get('/partidas-estandar')
      ]);
      setCategorias(resCategorias.data);
      setPartidas(resPartidas.data);
    } catch (error) {
      console.error('Error cargando datos:', error);
      Swal.fire({ icon: 'error', title: 'Error', text: 'Error al cargar datos' });
    } finally {
      setLoading(false);
    }
  };

  const cargarPartidas = async () => {
    try {
      const params = categoriaFiltro ? `?categoria=${categoriaFiltro}` : '';
      const response = await api.get(`/partidas-estandar${params}`);
      setPartidas(response.data);
    } catch (error) {
      console.error('Error cargando partidas:', error);
    }
  };

  const abrirModal = (partida = null) => {
    if (partida) {
      setEditando(partida.id);
      setFormData({
        CategoriaPartidaId: partida.CategoriaPartidaId,
        codigo: partida.codigo || '',
        nombre: partida.nombre,
        unidad: partida.unidad || 'glb',
        precio_referencia: partida.precio_referencia || '',
        descripcion: partida.descripcion || ''
      });
    } else {
      setEditando(null);
      setFormData({
        CategoriaPartidaId: categoriaFiltro || '',
        codigo: '',
        nombre: '',
        unidad: 'glb',
        precio_referencia: '',
        descripcion: ''
      });
    }
    setMostrarModal(true);
  };

  const cerrarModal = () => {
    setMostrarModal(false);
    setEditando(null);
    setFormData({
      CategoriaPartidaId: '',
      codigo: '',
      nombre: '',
      unidad: 'glb',
      precio_referencia: '',
      descripcion: ''
    });
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.nombre.trim()) {
      await Swal.fire({ icon: 'warning', title: 'Validación', text: 'El nombre es obligatorio', timer: 2000, showConfirmButton: false });
      return;
    }

    if (!formData.CategoriaPartidaId) {
      await Swal.fire({ icon: 'warning', title: 'Validación', text: 'La categoría es obligatoria', timer: 2000, showConfirmButton: false });
      return;
    }

    try {
      if (editando) {
        await api.put(`/partidas-estandar/${editando}`, formData);
        await Swal.fire({ icon: 'success', title: 'Actualizada', text: 'Partida actualizada exitosamente', timer: 2000, showConfirmButton: false });
      } else {
        await api.post('/partidas-estandar', formData);
        await Swal.fire({ icon: 'success', title: 'Creada', text: 'Partida creada exitosamente', timer: 2000, showConfirmButton: false });
      }
      cerrarModal();
      cargarPartidas();
    } catch (error) {
      console.error('Error guardando partida:', error);
      await Swal.fire({ icon: 'error', title: 'Error', text: error.response?.data?.error || 'Error al guardar partida' });
    }
  };

  const eliminarPartida = async (id) => {
    const { isConfirmed } = await Swal.fire({
      title: '¿Eliminar partida?',
      text: 'Esta acción no se puede deshacer.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar',
      confirmButtonColor: '#dc3545'
    });
    if (!isConfirmed) return;

    try {
      await api.delete(`/partidas-estandar/${id}`);
      await Swal.fire({ icon: 'success', title: 'Eliminada', text: 'Partida eliminada exitosamente', timer: 2000, showConfirmButton: false });
      cargarPartidas();
    } catch (error) {
      console.error('Error eliminando partida:', error);
      await Swal.fire({ icon: 'error', title: 'Error', text: error.response?.data?.error || 'Error al eliminar partida' });
    }
  };

  const partidasFiltradas = partidas.filter(p =>
    p.nombre.toLowerCase().includes(busqueda.toLowerCase()) ||
    p.codigo?.toLowerCase().includes(busqueda.toLowerCase())
  );

  if (loading) {
    return (
      <div className="materiales-container">
        <div className="loading">Cargando partidas...</div>
      </div>
    );
  }

  return (
    <div className="materiales-container">
      <div className="materiales-header">
        <div>
          <h1>📋 Partidas Estándar</h1>
          <p className="subtitle">Catálogo de partidas predefinidas para proyectos</p>
        </div>
        <div className="header-actions">
          <button
            className="btn btn-secondary"
            onClick={() => window.location.href = '/categorias-partida'}
          >
            📁 Categorías
          </button>
          <button className="btn btn-primary" onClick={() => abrirModal()}>
            + Nueva Partida
          </button>
        </div>
      </div>

      {/* Filtros */}
      <div className="filtros">
        <div className="filtro-group">
          <label>Categoría:</label>
          <select
            value={categoriaFiltro}
            onChange={(e) => setCategoriaFiltro(e.target.value)}
            className="form-control"
          >
            <option value="">Todas las categorías</option>
            {categorias.map((cat) => (
              <option key={cat.id} value={cat.id}>
                {cat.nombre}
              </option>
            ))}
          </select>
        </div>

        <div className="filtro-group">
          <label>Buscar:</label>
          <input
            type="text"
            value={busqueda}
            onChange={(e) => setBusqueda(e.target.value)}
            placeholder="Buscar por nombre o código..."
            className="form-control"
          />
        </div>
      </div>

      {/* Tabla */}
      <div className="tabla-container">
        {partidasFiltradas.length === 0 ? (
          <div className="empty-state">
            <p>No hay partidas registradas</p>
            <button className="btn btn-primary" onClick={() => abrirModal()}>
              Crear primera partida
            </button>
          </div>
        ) : (
          <table className="tabla">
            <thead>
              <tr>
                <th>Código</th>
                <th>Nombre</th>
                <th>Categoría</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {partidasFiltradas.map((partida) => (
                <tr key={partida.id}>
                  <td>{partida.codigo || '-'}</td>
                  <td>
                    <strong>{partida.nombre}</strong>
                    {partida.descripcion && (
                      <div className="descripcion-small">{partida.descripcion}</div>
                    )}
                  </td>
                  <td>
                    <span className="badge">{partida.categoria?.nombre}</span>
                  </td>
                  <td>
                    <div className="btn-group">
                      <button
                        className="btn-icon"
                        onClick={() => abrirModal(partida)}
                        title="Editar"
                      >
                        ✏️
                      </button>
                      <button
                        className="btn-icon danger"
                        onClick={() => eliminarPartida(partida.id)}
                        title="Eliminar"
                      >
                        🗑️
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {/* Modal */}
      {mostrarModal && (
        <div className="modal-overlay" onClick={cerrarModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h2>{editando ? 'Editar Partida' : 'Nueva Partida'}</h2>
              <button className="btn-close" onClick={cerrarModal}>
                ✕
              </button>
            </div>

            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Categoría *</label>
                <select
                  name="CategoriaPartidaId"
                  value={formData.CategoriaPartidaId}
                  onChange={handleChange}
                  className="form-control"
                  required
                >
                  <option value="">Seleccionar categoría</option>
                  {categorias.map((cat) => (
                    <option key={cat.id} value={cat.id}>
                      {cat.nombre}
                    </option>
                  ))}
                </select>
              </div>

              <div className="form-group">
                <label>Código</label>
                <input
                  type="text"
                  name="codigo"
                  value={formData.codigo}
                  onChange={handleChange}
                  placeholder="Ej: EST-001"
                  className="form-control"
                />
              </div>

              <div className="form-group">
                <label>Nombre *</label>
                <input
                  type="text"
                  name="nombre"
                  value={formData.nombre}
                  onChange={handleChange}
                  placeholder="Ej: Excavación general"
                  className="form-control"
                  required
                />
              </div>

                <div className="form-group">
                <label>Unidad *</label>
                <select
                  name="unidad"
                  value={formData.unidad}
                  onChange={handleChange}
                  className="form-control"
                  required
                >
                  <option value="glb">Global</option>
                  <option value="m²">m² - Metro cuadrado</option>
                  <option value="m³">m³ - Metro cúbico</option>
                  <option value="ml">ml - Metro lineal</option>
                  <option value="un">un - Unidad</option>
                  <option value="kg">kg - Kilogramo</option>
                  <option value="ton">ton - Tonelada</option>
                  <option value="saco">saco</option>
                  <option value="gal">gal - Galón</option>
                  <option value="%">% - Porcentaje</option>
                </select>
              </div>

              <div className="form-group">
                <label>Precio de Referencia</label>
                <input
                  type="number"
                  name="precio_referencia"
                  value={formData.precio_referencia}
                  onChange={handleChange}
                  placeholder={formData.unidad === '%' ? 'Ej: 8 para 8%' : 'Ej: 150.00'}
                  className="form-control"
                  step="0.01"
                  min="0"
                />
                <small className="text-muted">
                  {formData.unidad === '%' 
                    ? '💡 Porcentaje a aplicar sobre el subtotal de partidas directas'
                    : '💰 Precio unitario sugerido para esta partida'}
                </small>
              </div>


              <div className="form-group">
                <label>Descripción</label>
                <textarea
                  name="descripcion"
                  value={formData.descripcion}
                  onChange={handleChange}
                  placeholder="Descripción opcional..."
                  className="form-control"
                  rows="3"
                />
              </div>

              <div className="modal-actions">
                <button type="button" className="btn btn-secondary" onClick={cerrarModal}>
                  Cancelar
                </button>
                <button type="submit" className="btn btn-primary">
                  {editando ? 'Actualizar' : 'Crear'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default PartidasEstandar;